module.exports = __webpack_public_path__ + "img/11d2a44.png";